import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_MATERIAL_REQUEST = 'Material/GET_MATERIAL_REQUEST'
const GET_MATERIAL_SUCCESS = 'Material/GET_MATERIAL_SUCCESS'
const GET_MATERIAL_FAILURE = 'Material/GET_MATERIAL_FAILURE'

const FETCH_MATERIAL_REQUEST = 'Material/FETCH_MATERIAL_REQUEST'
const FETCH_MATERIAL_SUCCESS = 'Material/FETCH_MATERIAL_SUCCESS'
const FETCH_MATERIAL_FAILURE = 'Material/FETCH_MATERIAL_FAILURE'

const GET_MATERIAL_BY_CATEGORY_ID_REQUEST =
  'Material/GET_MATERIAL_BY_CATEGORY_ID_REQUEST'
const GET_MATERIAL_BY_CATEGORY_ID_SUCCESS =
  'Material/GET_MATERIAL_BY_CATEGORY_ID_SUCCESS'
const GET_MATERIAL_BY_CATEGORY_ID_FAILURE =
  'Material/GET_MATERIAL_BY_CATEGORY_ID_FAILURE'

const GET_MATERIAL_BY_HERO_ID_REQUEST =
  'Material/GET_MATERIAL_BY_HERO_ID_REQUEST'
const GET_MATERIAL_BY_HERO_ID_SUCCESS =
  'Material/GET_MATERIAL_BY_HERO_ID_SUCCESS'
const GET_MATERIAL_BY_HERO_ID_FAILURE =
  'Material/GET_MATERIAL_BY_HERO_ID_FAILURE'

const SAVE_MATERIAL_LIST = 'Material/SAVE_MATERIAL_LIST'
const SAVE_SELECTED_LIST = 'Material/SAVE_SELECTED_LIST'
const REMOVE_SELECTED_LIST = 'Material/REMOVE_SELECTED_LIST'

const DELETE_PRODUCT_REQUEST = 'Material/DELETE_PRODUCT_REQUEST'
const DELETE_PRODUCT_SUCCESS = 'Material/DELETE_PRODUCT_SUCCESS'
const DELETE_PRODUCT_FAILURE = 'Material/DELETE_PRODUCT_FAILURE'

const GET_MATERIAL_LIST_REQUEST = 'Material/GET_MATERIAL_LIST_REQUEST'
const GET_MATERIAL_LIST_SUCCESS = 'Material/GET_MATERIAL_LIST_SUCCESS'
const GET_MATERIAL_LIST_FAILURE = 'Material/GET_MATERIAL_LIST_FAILURE'

const CREATE_MATERIAL_REQUEST = 'Material/CREATE_MATERIAL_REQUEST'
const CREATE_MATERIAL_SUCCESS = 'Material/CREATE_MATERIAL_SUCCESS'
const CREATE_MATERIAL_FAILURE = 'Material/CREATE_MATERIAL_FAILURE'

const ADD_HERO_MATERIAL_REQUEST = 'Material/ADD_HERO_MATERIAL_REQUEST'
const ADD_HERO_MATERIAL_SUCCESS = 'Material/ADD_HERO_MATERIAL_SUCCESS'
const ADD_HERO_MATERIAL_FAILURE = 'Material/ADD_HERO_MATERIAL_FAILURE'

const UPDATE_MATERIAL_REQUEST = 'Material/UPDATE_MATERIAL_REQUEST'
const UPDATE_MATERIAL_SUCCESS = 'Material/UPDATE_MATERIAL_SUCCESS'
const UPDATE_MATERIAL_FAILURE = 'Material/UPDATE_MATERIAL_FAILURE'

const UPDATE_ADVANCE_REQUEST = 'Material/UPDATE_ADVANCE_REQUEST'
const UPDATE_ADVANCE_SUCCESS = 'Material/UPDATE_ADVANCE_SUCCESS'
const UPDATE_ADVANCE_FAILURE = 'Material/UPDATE_ADVANCE_FAILURE'

const UPDATE_MIN_QUANTITY_REQUEST = 'Material/UPDATE_MIN_QUANTITY_REQUEST'
const UPDATE_MIN_QUANTITY_SUCCESS = 'Material/UPDATE_MIN_QUANTITY_SUCCESS'
const UPDATE_MIN_QUANTITY_FAILURE = 'Material/UPDATE_MIN_QUANTITY_FAILURE'

const DELETE_MATERIAL_REQUEST = 'Material/DELETE_MATERIAL_REQUEST'
const DELETE_MATERIAL_SUCCESS = 'Material/DELETE_MATERIAL_SUCCESS'
const DELETE_MATERIAL_FAILURE = 'Material/DELETE_MATERIAL_FAILURE'
// Initialize State
const initialState = {
  user: {},
  isLoading: true,
  error: {},
  token: '',
  materials: [],
  searchMaterial: [],
  materialList: [],
  heroProducts: [],
  selectedList: [],
  material: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        materials: action.payload
      }
    case GET_MATERIAL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        searchMaterial: action.payload
      }
    case FETCH_MATERIAL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_MATERIAL_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_MATERIAL_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        material: action.payload
      }
    case GET_MATERIAL_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_MATERIAL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case ADD_HERO_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case ADD_HERO_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case ADD_HERO_MATERIAL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_MATERIAL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_ADVANCE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_ADVANCE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_ADVANCE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_MIN_QUANTITY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_MIN_QUANTITY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_MIN_QUANTITY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_MATERIAL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_MATERIAL_BY_CATEGORY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_MATERIAL_BY_CATEGORY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        materialList: action.payload
      }
    case GET_MATERIAL_BY_CATEGORY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_MATERIAL_BY_HERO_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_MATERIAL_BY_HERO_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroProducts: action.payload
      }
    case GET_MATERIAL_BY_HERO_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_SELECTED_LIST:
      return {
        ...state,
        error: action.error,
        selectedList: action.payload
      }
    case REMOVE_SELECTED_LIST:
      return {
        ...state,
        error: action.error,
        selectedList: action.payload
      }
    default:
      return state
  }
}

// backend ตอบ 400 พร้อมเหตุผล เช่น แก้หน่วยหรือลบวัสดุที่มีวัสดุของร้านผูกอยู่ (green2get-app spec 111)
const backendMessageOf = (err) =>
  (err.response && err.response.data && err.response.data.message) ||
  RESPONSE_MESSAGE.FAIL

// Action Creators
export const getMaterials = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_MATERIAL_REQUEST
      })

      const response = await API.get(EndPoints.PRODUCT + `/groupByCategory`)
      dispatch({
        type: GET_MATERIAL_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_MATERIAL_FAILURE
      })
    }
  }
}

export const fetchMaterials = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_MATERIAL_REQUEST
      })

      const response = await API.get(EndPoints.PRODUCT + `/searchMaterial`, {
        params: options
      })

      dispatch({
        type: FETCH_MATERIAL_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_MATERIAL_FAILURE
      })
    }
  }
}

export const getMaterial = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_MATERIAL_LIST_REQUEST
      })

      const response = await API.get(EndPoints.MATERAIAL + `/all`)
      dispatch({
        type: GET_MATERIAL_LIST_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_MATERIAL_LIST_FAILURE
      })
    }
  }
}
export const createMaterial = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_MATERIAL_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.MATERAIAL + `/createMaterial`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_MATERIAL_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
      return true
    } catch (err) {
      message.error(backendMessageOf(err))
      dispatch({
        type: CREATE_MATERIAL_FAILURE
      })
      return false
    }
  }
}
export const addHeroMaterial = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_MATERIAL_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.PRODUCT + `/addHeroMaterial`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_MATERIAL_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_MATERIAL_FAILURE
      })
    }
  }
}
export const updateMaterial = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_MATERIAL_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.MATERAIAL + `/updateMaterial`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_MATERIAL_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
      return true
    } catch (err) {
      message.error(backendMessageOf(err))
      dispatch({
        type: UPDATE_MATERIAL_FAILURE
      })
      return false
    }
  }
}
export const updateMaterialAdvance = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_ADVANCE_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.MATERAIAL + `/updateMaterialAdvance`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_ADVANCE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(backendMessageOf(err))
      dispatch({
        type: UPDATE_ADVANCE_FAILURE
      })
    }
  }
}
export const updateMinQuantity = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_MIN_QUANTITY_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.PRODUCT + `/admin/updateMinQuantity`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_MIN_QUANTITY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_MIN_QUANTITY_FAILURE
      })
    }
  }
}

export const deleteMaterial = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_MATERIAL_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.MATERAIAL + `/material` + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_MATERIAL_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(backendMessageOf(err))
      dispatch({
        type: DELETE_MATERIAL_FAILURE
      })
    }
  }
}

export const getMaterialByCategoryId = (categoryId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_MATERIAL_BY_CATEGORY_ID_REQUEST
      })

      const response = await API.get(
        EndPoints.PRODUCT + `/listByCategory/${categoryId}`
      )
      dispatch({
        type: GET_MATERIAL_BY_CATEGORY_ID_SUCCESS,
        payload: response.data.data
      })
    } catch (err) {
      dispatch({
        type: GET_MATERIAL_BY_CATEGORY_ID_FAILURE
      })
    }
  }
}

export const getMaterialByHeroId = (heroId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_MATERIAL_BY_HERO_ID_REQUEST
      })

      const response = await API.get(EndPoints.PRODUCT + `/hero/${heroId}`)
      dispatch({
        type: GET_MATERIAL_BY_HERO_ID_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_MATERIAL_BY_HERO_ID_FAILURE
      })
    }
  }
}

export const saveSelectedList = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SAVE_SELECTED_LIST,
      payload: data
    })
  }
}

export const saveMaterialList = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SAVE_MATERIAL_LIST,
      payload: data
    })
  }
}

export const removeSelectedList = (data) => {
  return async (dispatch) => {
    dispatch({
      type: REMOVE_SELECTED_LIST,
      payload: data
    })
  }
}

export const deleteProductById = (productId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_PRODUCT_REQUEST
      })
      await API.delete(EndPoints.PRODUCT + `/${productId}`)
      dispatch({
        type: DELETE_PRODUCT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_PRODUCT_FAILURE
      })
    }
  }
}
